import { AxiosError } from 'axios'
import useSWR from 'swr'
import { PublicConfiguration } from 'swr/dist/types'
import { api } from '~/data/api'
import { useAuth } from './useAuth'

interface CustomOptions {
  logoutOnUnauthorized?: boolean
}

type useFetchOptions = CustomOptions & Partial<PublicConfiguration<any, any, any>>

const defaultOptions: useFetchOptions = {
  revalidateOnFocus: true,
  revalidateOnMount: true,
  revalidateOnReconnect: false,
  logoutOnUnauthorized: true,
}

export function useFetch<Data = any, Error = any>(
  url: string,
  shouldFetch = true,
  options = defaultOptions,
) {
  const { handleLogout } = useAuth()
  const { data, error, mutate } = useSWR<Data, Error>(
    url,
    async (url: string) => {
      if (!shouldFetch) return
      try {
        const response = await api().get(url)

        const data = response.data
        if (!data['_id']) {
          return response.data
        }

        data.id = data._id
        return data
      } catch (rawError: any) {
        const err = rawError as AxiosError
        if (options.logoutOnUnauthorized && err?.response?.status === 401) {
          handleLogout()
        }
      }
    },
    options,
  )

  return { data, error, mutate, loading: !data && !error }
}
